import * as React from 'react';

const AnthologyLogo = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 50" {...props}>
      <g data-name="spacer icon">
        <path d="M0 49h30v1H0zM0 0h30v1H0z" />
      </g>
      <g data-name="anthology icon copy 2">
        <path fill="#8dc641" d="M9.66 14.23h2.64v19.7H9.66z" />
        <path fill="#ffc316" d="M13.57 9.49h2.64v24.44h-2.64z" />
        <path fill="#f15b27" d="M17.51 14.23h2.64v19.7h-2.64z" />
        <path fill="#7e549f" d="M21.42 20.12h2.64v13.81h-2.64z" />
        <path fill="#1aafe6" d="M5.75 20.12h2.64v13.81H5.75z" />
      </g>
    </svg>
  );
};

export default AnthologyLogo;
